import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import axios from "axios";
import {css} from "@emotion/core";
import {style} from "variables/Variables.jsx";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import {confirmAlert} from "react-confirm-alert";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

class TerminalDetails extends Component{
    constructor(props) {
        super(props);
        this.state={
            table:{},
            _notificationSystem: null,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            monthID:'042020',
            user_id:'',
            merchant_name:'Reliance Retail Limited',
            newRiseModel: false,
            changedItems:[],
            loading: true,
            is_record: true,
            issue_cat:'Terminal migrated to UPI Next',
            isChange: false,
            otherIssue:''
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        //var _notificationSystem = this.refs.notificationSystem;
    }

    toggleNewRiseModel() {
        this.setState({
            newRiseModel: !this.state.newRiseModel,
        })
    }

    // callChildMethod() {
    //     //this._getAllMerchants();
    //     this.get_filtered_data('','',this.state.monthID )
    // }
    get_filtered_data(mid,cid,sid,month){
        if ($.fn.DataTable.isDataTable('#MerchantTdetailsTable')) {
            $('#MerchantTdetailsTable').DataTable().clear().destroy();
        }
        this.setState({
            loading: true,
            is_record: true,
            merchantID:mid,
            chainID:cid,
            monthID:month
        });
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        let postdatatd = {
            merchant_codes: mid,
            chain_codes: cid,
            store_codes: sid,
            month: month
        };
        axios.post(config.get('API_URL')+'/invoice/terminal_details_rows/', postdatatd,{
        headers: {
            Authorization: ` ${localStorage.usertoken}`
        }
    }).then(response => {
            if(Array.isArray(response.data.data) && response.data.data.length){
            //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';
                // tableHeaders.push({
                //     sTitle: "" ,
                //     mData: "id"
                //
                // });
                // tableBody.push({
                //     data: "id",
                // });

                keys.forEach(function (k) {
                    if(k=='id' || k=='latestversion') {
                        keyVal = '';
                    }
                    else{
                        keyVal = k;
                    }
                    tableHeaders.push({
                        sTitle: keyVal,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    });
                    headerList.push(k);
                });
                // console.log(JSON.stringify(tableHeaders));
                // console.log(JSON.stringify(tableBody));
                this.setState({
                    loading: false,
                    is_record: true
                });
                this.get_filtered_installation_data(mid, cid, sid, month, tableHeaders, tableBody,headerList);
            }else {
                if ($.fn.DataTable.isDataTable('#MerchantTdetailsTable')) {
                    $('#MerchantTdetailsTable').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                });
            }
        })
    }

    get_filtered_installation_data(mid,cid,sid,month,tableHeaders,tableBody,headerList){
        let idIndex = headerList.indexOf("id");
        let postdatatd2 = {
            merchant_codes: mid,
            chain_codes: cid,
            store_codes: sid,
            month: month
        };
        //alert(idIndex);
        if ($.fn.DataTable.isDataTable('#MerchantTdetailsTable')) {
            $('#MerchantTdetailsTable').DataTable().clear().destroy();
        }
        $('#MerchantTdetailsTable').html('');
        var merchantDataTable1 = $('#MerchantTdetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": true,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/merchant_terminal_details",
                    type: 'POST',
                    data: postdatatd2,
                    dataSrc:function ( json ) { //console.log(json);
                       return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns:tableHeaders,
                columns: tableBody,
                // "columnDefs": [{
                //     //"width": "100px",
                //     "targets": 0,
                //     "data": "data",
                //     "createdCell": (td, cellData, rowData, row, col) => {
                //         $(td).text("");
                //         if(rowData['is_active'] == 0) {
                //             $(td).closest('tr').css({"background-color": "#fff", "opacity": "0.30"});
                //         }
                //         $(td).append("<input type='checkbox' class='raisreq'>");
                //         $(td).click(e => {
                //             this.check_req(e,rowData["id"]);
                //         })
                //     },
                //     bSortable: false,
                // },
                // // {
                // //     render: function (data) {
                // //         return '<td></td>';
                // //     },
                // //     targets: idIndex+1,
                // //     "width": "0%",
                // //     bSortable: false,
                // //     aTargets: [ -1 ]
                // // },
                // {
                //     render: function (data) {
                //         return '<td></td>';
                //     },
                //     targets: idIndex,
                //     "width": "0%",
                //     bSortable: false,
                //     aTargets: [ -1 ]
                // },
                // {
                //     render: function (data) {
                //         let status = "No"
                //         if(data==1){ status = 'Yes'}
                //         return '<td>'+status+'</td>';
                //     },
                //     targets: idIndex-1,
                //     "width": "0%",
                //     bSortable: false,
                //     aTargets: [ -1 ]
                // },
                // ]
            });
        }

    check_req(e, rowData){
        let item_list = this.state.changedItems
        let checked_list = rowData;
        console.log(checked_list);
        if(e.target.checked===true) {
            this.setState({
                changedItems: [...this.state.changedItems,  rowData],
                isChange: true
            });
        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                this.setState({
                    changedItems: item_list,
                    isChange: true
                })
            }
        }

        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }


    // chaneReason(e){
    //     this.setState({
    //         issue_cat: e.target.value,
    //     });
    //     if(e.target.value!='Other'){
    //         this.setState({
    //             otherIssue:''
    //         })
    //     }
    // }
    // enableTerminal(){
    //     if(Array.isArray(this.state.changedItems) && this.state.changedItems.length){
    //         confirmAlert({
    //             title: 'Question',
    //             message: 'Are you sure you want to Enable?.',
    //             buttons: [{
    //                 label: 'Yes',
    //                 onClick: () => {
    //                     this.handleClickEnable();
    //                 }
    //             },
    //                 {
    //                     label: 'No',
    //                 }
    //             ]
    //         });
    //     }
    //     else{
    //         this.handleNotificationClick("tr", 3, "Please select at least one record");
    //     }
    // }
    // disableTerminal(){
    //     if(Array.isArray(this.state.changedItems) && this.state.changedItems.length){
    //         this.handleClickDisable();
    //
    //         // confirmAlert({
    //         //     title: 'Question',
    //         //     message: 'Are you sure you want to disable?.',
    //         //     buttons: [{
    //         //         label: 'Yes',
    //         //         onClick: () => {
    //         //             this.handleClickDisable();
    //         //         }
    //         //     },
    //         //         {
    //         //             label: 'No',
    //         //         }
    //         //     ]
    //         // });
    //     }
    //     else{
    //         this.handleNotificationClick("tr", 3, "Please select at least one record");
    //     }
    // }
    // handleClickDisable(){
    //     console.log(this.state.changedItems);
    //     let issueCat = this.state.issue_cat
    //     if(this.state.issue_cat=='Other') {
    //         issueCat = this.state.otherIssue
    //     }
    //
    //     axios.post(config.get('API_URL')+'/invoice/disable_terminals/',
    //         {
    //             terminalIds: this.state.changedItems,
    //             issue_cat: issueCat
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             },
    //         })
    //         .then(response => {
    //             // console.log("disableeeee");
    //             // console.log(response);
    //             this.setState({
    //                 newRiseModel: false
    //             })
    //             this.get_filtered_data(this.state.merchantID,this.state.chainID,this.state.monthID);
    //         }).catch( err=> {
    //           console.log(err);
    //         })
    // }
    // handleClickEnable(){
    //     axios.post(config.get('API_URL')+'/invoice/enable_terminals/',
    //         {
    //             terminalIds: this.state.changedItems
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             },
    //         })
    //         .then(response => {
    //             console.log(response);
    //             this.get_filtered_data(this.state.merchantID,this.state.chainID,this.state.monthID);
    //         }).catch( err=> {
    //         console.log(err);
    //     })
    // }
    // changeOther(e){
    //     this.setState({
    //         otherIssue:e.target.value
    //     })
    // }
    render() {
        // console.log(this.state.changedItems);
        // console.log(this.state.issue_cat);
        return(
            <div className="row tansactionTabs">
                <NotificationSystem ref="notificationSystem" style={style} />
                <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                {this.state.is_record ?
                <div className="content-tdetails-table table-full-width table-responsive">
                    <table id="MerchantTdetailsTable" className="table table-striped table-hover">

                    </table>
                    {/*<div className="col-md-3 pull-right">*/}
                    {/*    <button type="button" className="btn btn-primary" onClick={this.enableTerminal.bind(this)} disabled={!this.state.isChange}>Enable</button> &nbsp; &nbsp;*/}
                    {/*    <button type="button" className="btn btn-secondary" onClick={this.toggleNewRiseModel.bind(this)} disabled={!this.state.isChange}>Disable</button>*/}
                    {/*</div>*/}
                </div>:
                    <div className="empty_data"> No record Found</div>
                }
                {/*<Modal isOpen={this.state.newRiseModel} toggle={this.toggleNewRiseModel.bind(this)} >*/}
                {/*    <ModalHeader toggle={this.toggleNewRiseModel.bind(this)}>Rise correction</ModalHeader>*/}
                {/*    <ModalBody>*/}
                {/*        <div className="">*/}
                {/*            <div className="col-md-12 col-xs-12">*/}
                {/*                <FormGroup>*/}
                {/*                    <div className="col-md-3 col-xs-12">*/}
                {/*                        <Label for="firstName">Issue Category</Label>*/}
                {/*                    </div>*/}
                {/*                    <div className="col-md-6 col-xs-12">*/}
                {/*                        <select name="userType" className="form-control" onChange={this.chaneReason.bind(this)} value={this.state.issue_cat} >*/}
                {/*                            <option value="Terminal migrated to UPI Next">Terminal migrated to UPI Next</option>*/}
                {/*                            <option value="Terminal not transacting">Terminal not transacting</option>*/}
                {/*                            <option value="Incorrect store code">Incorrect store code</option>*/}
                {/*                            <option value="Other">Other</option>*/}
                {/*                        </select>*/}
                {/*                    </div>*/}
                {/*                </FormGroup>*/}

                {/*            </div>*/}

                {/*            {this.state.issue_cat=='Other'?*/}
                {/*            <div className="col-md-12 col-xs-12">*/}
                {/*                <br/>*/}
                {/*                <FormGroup>*/}
                {/*                    <div className="col-md-3 col-xs-12">*/}
                {/*                        <Label for="firstName">Other Issue</Label>*/}
                {/*                    </div>*/}
                {/*                    <div className="col-md-6 col-xs-12">*/}
                {/*                        <input type="text" value={this.state.otherIssue} name="otherissue" className="form-control" onChange={this.changeOther.bind(this)}/>*/}
                {/*                    </div>*/}
                {/*                </FormGroup>*/}
                {/*            </div>: null}*/}
                {/*        <div className="clearfix"></div>*/}
                {/*        </div>*/}
                {/*    </ModalBody>*/}
                {/*    <ModalFooter>*/}
                {/*        <Button color="primary" onClick={this.disableTerminal.bind(this)} >Submit</Button>{' '}*/}
                {/*        <Button color="secondary" onClick={this.toggleNewRiseModel.bind(this)}>Cancel</Button>*/}
                {/*    </ModalFooter>*/}
                {/*</Modal>*/}
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default TerminalDetails